import { apiEndPoints, apiMethods } from '../../../../../../utils/apiConstants'
import customAxios from '../../../../../../utils/customAxios'

export const sponserCommissionListingDataThunk = async (body) => {
	try {
		const responseJson = await customAxios[apiMethods.post](apiEndPoints?.sponsorCommissionListing, body)
		const data = responseJson.data
		return data
	} catch (error) {
		throw error
	}
}

export const aurCommissionListingDataThunk = async (body) => {
	try {
		const responseJson = await customAxios[apiMethods.post](apiEndPoints?.aurCommissionListingInUser, body)
		const data = responseJson.data
		return data
	} catch (error) {
		throw error
	}
}
export const fetchReferralCommissionDataThunk = async (body) => {
	try {
		const responseJson = await customAxios[apiMethods.post](apiEndPoints?.getReferralCommissionOfUser, body)
		const data = responseJson.data
		return data
	} catch (error) {
		throw error
	}
}

export const fetchReferralCommissionTeamViewDataThunk = async (_id) => {
	try {
		const responseJson = await customAxios[apiMethods.get](apiEndPoints?.referralCommTeamView(_id))
		const data = responseJson.data
		return data
	} catch (error) {
		throw error
	}
}

export const fetchOrderTreeDataThunk = async (_id) => {
	try {
		const responseJson = await customAxios[apiMethods.get](apiEndPoints?.orderTreeDetails(_id))
		const data = responseJson.data
		return data
	} catch (error) {
		throw error
	}
}
